import React from 'react'
import { Trans } from '@ui/i18n/trans.tsx';

import { StaticPageTitle } from '@common/seo/static-page-title.tsx';
import { AdHost } from '@common/admin/ads/ad-host.tsx';

import { useLibraryStore } from '@app/web-player/library/state/likes-store.ts';
import { useUserLikedLabels } from '@player/web-player/library/requests/use-user-liked-labels.ts';

import { useAuth } from '@common/auth/use-auth.ts';
import { useTrans } from '@ui/i18n/use-trans.ts';

import { PageErrorMessage } from '@common/errors/page-error-message.tsx';
import { TagItem } from '@player/custom/TagItem.tsx';

import { SearchIcon } from '@ui/icons/material/Search.tsx';
import { message } from '@ui/i18n/message.ts';

import { TextField } from '@ui/forms/input-field/text-field/text-field.tsx';
import { InfiniteScrollSentinel } from '@common/ui/infinite-scroll/infinite-scroll-sentinel.tsx';

import { MediaPageNoResultsMessage } from '@app/web-player/layout/media-page-no-results-message.tsx';

export function LibraryLabelsPage() {
    // @ts-ignore
    const trackTags = useLibraryStore(s => Object.keys(s.tag).length);

    const query = useUserLikedLabels('me',
        {
            willSortOrFilter: true
        }
    );
    const {
        isInitialLoading,
        searchQuery,
        setSearchQuery,
        items,
        isError,
    } = query;

    const { user } = useAuth();
    const { trans } = useTrans();

    if (isError) {
        return <PageErrorMessage />;
    }

    return (
        <div>
            <StaticPageTitle>
                <Trans message="Your labels" />
            </StaticPageTitle>

            <AdHost slot="general_top" className="mb-34" />
            <div className="mb-34 flex flex-wrap items-center justify-between gap-24">
                <h1 className="w-max whitespace-nowrap text-2xl font-semibold md:w-full">
                    {trackTags ? (
                        <Trans
                            message="[one 1 liked label|other :count liked labels]"
                            values={{count: trackTags}}
                        />
                    ) : (
                        <Trans message="My labels" />
                    )}
                </h1>

                <TextField
                    value={searchQuery}
                    onChange={e => setSearchQuery(e.target.value)}
                    className="max-w-512 flex-auto"
                    size="sm"
                    startAdornment={<SearchIcon />}
                    placeholder={trans(message('Search within labels'))}
                />
            </div>
            {(items || [])?.map(item => (
                <TagItem
                    {...item}
                    key={item.id}
                />
            ))}

            {query && <InfiniteScrollSentinel query={query} />}

            {!items.length && !isInitialLoading && (
                <MediaPageNoResultsMessage
                    className="mt-34"
                    searchQuery={searchQuery}
                    description={
                        <Trans message="You have not added any labels to your library yet." />
                    }
                />
            )}
            <AdHost slot="general_bottom" className="mt-34" />
        </div>
    )
}
